<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <logo />
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">{{ t('Page Not Found') }} 🕵🏻‍♀️</h2>
        <p class="mb-2">
          {{ t('Page Not Found Description') }}
        </p>

        <b-button variant="primary" class="mb-2 btn-sm-block" :to="{ path: '/' }">
          {{ t('Go To Dashboard') }}
        </b-button>

        <!-- image -->
        <b-img fluid :src="imgUrl" alt="Error page" />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
import { BLink, BButton, BImg } from 'bootstrap-vue';
import Logo from '@core/layouts/components/Logo.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import store from '@/store/index';

export default {
  components: {
    Logo,
    BLink,
    BButton,
    BImg
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      downImg: require('@/assets/images/pages/error.svg')
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties, global-require
        this.downImg = require('@/assets/images/pages/error-dark.svg');
        return this.downImg;
      }
      return this.downImg;
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
